import React from 'react';

import { Feature } from 'config/features';
import { SwiperOptions } from 'swiper/types/swiper-options';

import { useFeature } from 'hooks/useFeature';

import { useRecommender } from './__hooks/useRecommender';
import ListWrapper from './__partials/ListWrapper';

interface RecommenderProps {
    classListObject?: {
        RecommenderWrapper?: string;
        Slide?: string;
        SliderWrapper?: string;
    };
    withHeaderLink?: boolean;
    swiperSettings?: SwiperOptions;
}

const Recommender = ({
    classListObject,
    withHeaderLink = false,
    swiperSettings = {
        breakpoints: {
            0: { slidesPerView: 2 },
            1260: { slidesPerView: 3 },
        },
    },
}: RecommenderProps) => {
    const {
        isFetching,
        hotelItemList,
        recommenderTargets,
        hotelName,
        onMoreClick,
    } = useRecommender();

    const isS4RefreshTopEnabled = useFeature(Feature.S4RefreshTop);

    if (isFetching || !!hotelItemList.length) {
        return (
            <>
                {recommenderTargets.map((target) => (
                    <ListWrapper
                        key={target.id}
                        isFetching={isFetching}
                        hotelItemList={hotelItemList}
                        target={target}
                        hotelName={hotelName}
                        onMoreClick={onMoreClick}
                        isS4RefreshTopEnabled={isS4RefreshTopEnabled}
                        classListObject={{
                            RecommenderWrapper:
                                classListObject?.RecommenderWrapper,
                            SliderWrapper: classListObject?.SliderWrapper,
                            Slide: classListObject?.Slide,
                        }}
                        withHeaderLink={withHeaderLink}
                        swiperSettings={swiperSettings}
                    />
                ))}
            </>
        );
    }

    return null;
};

export default Recommender;
